export const elements = [
  {name: 'Assets', color: '#EBF2FF'},
  {name: 'Liabilities', color: '#FFF8EB'},
  {name: 'Equity', color: '#ECF6F7'},
  {name: 'Revenues', color: '#F4F1FA'},
  {name: 'Expenses', color: '#FAEDED'}
];